import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { withStyles } from '@material-ui/styles';
import { Switch, Button,
    Dialog, DialogTitle, DialogContent, DialogActions, TextField, Checkbox, FormControlLabel,
    FormControl, InputLabel, Select, MenuItem, FormGroup, FormLabel
    } from '@material-ui/core';
import GearIcon from '@material-ui/icons/SettingsSharp'; 

import PropTypes from 'prop-types';
import moment from 'moment';
import validate from 'validate.js'; 
import schema from '../../SignUp/SignupSchema';

const styles = (theme) => ({
    root: {
        minHeight: 400,
        minWidth: 300,
        fontFamily: 'Helvetica',
        '@media only screen and (max-width: 450px)': {
            // marginLeft: 0,
            // paddingTop: 54,
        },
    },
    content: {
        padding: 24,
        fontSize: 14,
    },

    textField: {
        marginTop: '8px',
      },
    inlineField: {
        margin: '8px 20px',
        display: 'inline-block'
    },
    inlineSelector: {
        margin: '8px 20px',
        display: 'inline-block',
        width: 168,
    },
    inlineCheckbox: {
        margin: '8px 20px',
        display: 'inline-block',
        verticalAlign: 'bottom'
    },
    // subscriptionBlock: {
    //     margin: '10px 20px',
    //     display: 'inline-block',
    //     verticalAlign: 'bottom'
    // },
});



export class AddUserForm extends React.PureComponent {
    constructor(...args) {
        super(...args);

        const {memberGroups, memberTypes} = this.props;

        if( memberGroups ) {
            const mgs = memberGroups.map(item => ({value: item}));
            schema.memberGroup.presence.select = mgs;
        }
        const organization = localStorage.getItem('organization') ? JSON.parse(localStorage.getItem('organization')) : '';
        if(organization){
            schema.subscribed.presence.select = organization.courses;
        }
        this.state = {
            formValid: false,
            formState: {
                isValid: false,
                values: {
                    password: 'changeMyPassword!'
                },
                touched: {
                    password: true
                },
                errors: {},
                isSuccessfull: false
              }
        };
    }
  
    handleChangeSwitch = (event, index) => {
        const { tempData } = this.state;
        tempData[index].show = event.target.checked;
        
            this.setState({ tempData, forceRefresh: !this.state.forceRefresh });
        
    }

    handleCancel = () => {
        this.props.cancel();
    }

    handleSave = () => {
        this.props.updateColumns(this.state.tempData);
    }

    hasError = field =>
    this.state.formState.touched[field] && this.state.formState.errors[field] ? true : false;

    validForm = (formState) => {
        let valid = true;

        Object.keys(schema).forEach(key => {
            const item = schema[key];
            if (item.presence.admin === 'required') {
                // see if it's valid
                if(!formState.touched[key] || formState.errors[key]) {
                    valid = false;
                }
            }
        })
        return valid;
      }

    handleChange = event => {
        event.persist();
        const newState = this.state.formState;
        const field = event.target.name;
        if(event.target.type !== 'checkbox'){
            newState.values[field] = event.target.value;
        } else {
            newState.values.subscriptions =  {...newState.values.subscriptions, [field]: event.target.checked} ;

        }
        console.log(newState.values)
        newState.touched[field] = true;
        const errors = validate(newState.values, schema);
        //const errors = false
        newState.isValid = errors ? false : true;
        newState.errors = errors || {};
        console.log(schema)
        if(errors && event.target.value === '' && schema[field] && schema[field].presence.admin !== 'required' && newState.errors[field]) {
            delete newState.errors[field];
            delete newState.touched[field];
        }
        let isValid = this.validForm(newState);
        if (isValid && newState.values.email !== newState.values.emailAgain) {
            isValid = false;
            newState.errors.emailAgain = [`Emails must match`];
        }
        this.setState({formValid: isValid, formState: newState, forceRefresh: !this.state.forceRefresh })
      
      };

    render() {
     
        const { classes } = this.props;
        const { formState } = this.state;

        return (
            <div className={classes.root} >
             <Dialog open={true} onClose={this.props.onClose}>
                    <DialogTitle>Create a New User</DialogTitle>
                    <DialogContent style={{minWidth:400, paddingLeft: 80, paddingRight: 60}}>
                        {Object.keys(schema).map(key => {
                            const item = schema[key];
                            if( item.presence.admin !== 'hidden' && !item.checked && !item.presence.select) {
                                return (
                                    <div className={classes.inlineField}>
                                        <TextField
                                            className={classes.textField}
                                            error={this.hasError(key)}
                                            fullWidth
                                            helperText={
                                                this.hasError(key) ? formState.errors[key][0] : null
                                            }
                                            label={item.presence.label || key}
                                            name={key}
                                            onChange={this.handleChange}
                                            type="text"
                                            value={formState.values[key] || ''}
                                            variant="standard"
                                        />
                                    </div>
                            )
                            }
                            //Course Select
                            if (item.presence.admin !== 'hidden' && item.checked === true) {
                                return (
                                    <FormControl component='fieldset' className={classes.inlineCheckbox}>
                                    <FormLabel component="legend">Choose Subscriptions(optional)</FormLabel>
                                    <FormGroup>
                                    {item.presence.select.map(el => 
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    error={this.hasError(key)}
                                                    checked={formState.values.subscriptions ? formState.values.subscriptions[el.alias] : false}
                                                    className={classes.policyCheckbox}
                                                    color="primary"
                                                    name={el.alias}
                                                    onChange={this.handleChange}
                                                />
                                            }
                                            label={el.name || key}
                                        />
                                    )}
                                    </FormGroup>
                                    </FormControl>
                                )
                            }
                            if (item.presence.admin !== 'hidden' && item.presence.select && item.presence.select.length > 0) {
                                return (
                                    <div className={classes.inlineSelector}>
                                        <FormControl className={classes.formControl}>
                                            <InputLabel id={`label-selector-${key}`}>{item.presence.label}</InputLabel>
                                            <Select
                                                labelId={`label-selector-${key}`}
                                                id={`selector-${key}`}
                                                value={formState.values[key] || ''}
                                                onChange={this.handleChange}
                                                fullWidth
                                                name={key}
                                            >
                                                {item.presence.select.map(option => (
                                                     <MenuItem value={option.value}>{option.label || option.value}</MenuItem>
                                                ))
                                                }

                                            </Select>
                                        </FormControl>

                                    </div>
                                )
                            }
                            return null;
                        })}                        
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.props.onClose}>Cancel</Button>
                        <Button 
                            onClick={() => (this.props.onClose({data: this.state.formState.values})) }
                            autoFocus color="primary"
                            disabled={!this.state.formValid}
                            variant="contained"
                            >
                                Create User
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

AddUserForm.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AddUserForm);
